import {
  MobileInterscroller,
  Rectangle,
  HalfpageContent,
} from "components/adbutler-advertisements"

import {
  MostReadArticlesVertical,
  RelatedArticlesVertical,
  ConstructionMethodsVertical,
} from "components/article-components/link-modules"

import React, { useEffect, useState } from "react"
import { ArticleContentComponentContainer } from "../utils"

export const Paragraph = ({
  content,
  self_ad_content = null,
  advertisement = "",
  has_mobile_interscroller,
  ressort,
  adbutler_page_id,
  adbutler_place,
  tags = [],
  topic = "",
}) => {
  let pre_ad_content_has_open_tag = false
  const [pre_ad_content, post_ad_content] = !!advertisement
    ? content.split(" ").reduce(
        ([pre_ad_content, post_ad_content], current) => {
          pre_ad_content_has_open_tag =
            !!/<[^/][^>]*>/g.test(pre_ad_content) &&
            !/<\/[^>]*>/g.test(pre_ad_content)
          if (
            pre_ad_content.length >= content.length / 6 &&
            !pre_ad_content_has_open_tag
          ) {
            return [pre_ad_content, post_ad_content + current + " "]
          }
          return [pre_ad_content + current + " ", post_ad_content]
        },
        ["", ""]
      )
    : [null, null]

  const [is_mobile, set_is_mobile] = useState(true)

  useEffect(() => {
    set_is_mobile(window.innerWidth <= 1024)
  }, []) //eslint-disable-line

  const vertical_ads = {
    rectangle: (
      <Rectangle
        {...{ ressort, adbutler_page_id, adbutler_place, tags, topic }}
      />
    ),
    halfpage: (
      <HalfpageContent
        {...{ ressort, adbutler_page_id, adbutler_place, tags, topic }}
      />
    ),
    most_read_articles: (
      <MostReadArticlesVertical
        {...{ most_read_articles: self_ad_content, ressort }}
      />
    ),
    construction_methods: (
      <ConstructionMethodsVertical
        {...{ construction_method_blogposts: self_ad_content, ressort }}
      />
    ),
    related_articles: (
      <RelatedArticlesVertical
        {...{ related_articles: self_ad_content, ressort }}
      />
    ),
  }

  return (
    <React.Fragment>
      <ArticleContentComponentContainer>
        {!!advertisement ? (
          <React.Fragment>
            <span
              className="bfz-article-paragraph"
              dangerouslySetInnerHTML={{ __html: pre_ad_content }}
            ></span>

            {is_mobile ? null : (
              <div className="rectangle-ad-in-article my-2">
                {vertical_ads[advertisement]}
              </div>
            )}

            <span
              className="bfz-article-paragraph"
              dangerouslySetInnerHTML={{ __html: post_ad_content }}
            ></span>
            {is_mobile ? (
              <div
                className={
                  advertisement === "related_articles"
                    ? undefined
                    : "rectangle-ad-in-article"
                }
              >
                {vertical_ads[advertisement]}
              </div>
            ) : null}
          </React.Fragment>
        ) : (
          <p
            className="bfz-article-paragraph"
            dangerouslySetInnerHTML={{ __html: content }}
          ></p>
        )}
      </ArticleContentComponentContainer>
      {has_mobile_interscroller ? (
        <MobileInterscroller {...{ ressort, tags, topic }} />
      ) : null}
    </React.Fragment>
  )
}
